import SurveySubmissionNotification from './SurveySubmissionNotification';

export default SurveySubmissionNotification;
